<template>
  <footer class="site-footer">
    <div class="footer-inner">
      <div class="footer-brand">
        <span class="footer-logo">Ψ SignalRoom</span>
        <p>signalroom.vip — Independent, research-informed self-assessments for education and personal insight</p>
      </div>
      <div class="footer-links">
        <a href="/about.html">About</a>
        <a href="/privacy.html">Privacy</a>
        <a href="/terms.html">Terms</a>
      </div>
      <div class="footer-contact">
        <p>Contact: <a href="mailto:tudouchenxiaoze@gmail.com">tudouchenxiaoze@gmail.com</a></p>
        <p class="copyright">© 2026 SignalRoom · signalroom.vip</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default { name: 'AppFooter' }
</script>

<style scoped>
.site-footer {
  background: #0d1f3c;
  color: rgba(255,255,255,0.65);
  margin-top: 4rem;
}

.footer-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2.5rem 1.5rem;
  display: grid;
  grid-template-columns: 2fr 1fr 1.5fr;
  gap: 2rem;
}

.footer-logo {
  font-family: 'Playfair Display', serif;
  font-size: 1.1rem;
  color: #e8c547;
  font-weight: 700;
}

.footer-brand p { margin-top: 0.5rem; font-size: 0.85rem; }

.footer-links {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.footer-links a {
  color: rgba(255,255,255,0.65);
  text-decoration: none;
  font-size: 0.875rem;
}

.footer-links a:hover { color: #e8c547; }

.footer-contact a { color: #e8c547; text-decoration: none; }
.footer-contact p { font-size: 0.85rem; margin-bottom: 0.35rem; }
.copyright { opacity: 0.5; font-size: 0.78rem !important; }

@media (max-width: 768px) {
  .footer-inner { grid-template-columns: 1fr; }
}
</style>
